import { LocalStorageGenerator } from '../../utils';
import { SamplingMapState } from './SamplingMap';

export const SamplingMapStateStorage = LocalStorageGenerator<Partial<SamplingMapState>>('SamplingMapState', {});
